<template>
  <b-container fluid class="portal">
    <b-row class="row">
      <b-col lg="2" xl="1" id="portal-menu">
        <portalMenu />
      </b-col>
      <b-col id="content-area">
        <loading />
        <router-view />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import portalMenu from "./Menu.vue";
import loading from "@/components/portal/global/loading";
export default {
  name: "carrierPortal",
  components: {
    portalMenu,
    loading
  }
};
</script>